import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Tafsil from "./Tafsil";
import { Header } from '../Header';
import { Footer } from '../Footer';
import { NavLink } from 'react-router-dom';
import CashDesk from "../CashDesk";
import BankAccount from "../BankAccount";
import Person from "../Person";
import Stuff from "../Stuff";
import AccountTransfer from "./AccountTransfer";
import Unit from "../Buildings/Unit";
import OrgUnit from "../OrgUnit";
import Solution from "../Solution/Solution";

export default class Tafsils extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'tafsil',
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            filters: {
                code: '',
                type: -1
            },
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 22
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData();
            });
    }
    doEdit(record) {
        if (record.accountTafsilType === 1) {
            this.onEditPerson(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 2) {
            this.onEditStuff(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 3) {
            this.onEditBankAccount(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 4) {
            this.onEditCashDesk(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 7) {
            this.onEditBuildingUnit(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 8) {
            this.onEditOrgUnit(record.tafsilObjectId);
            return;
        }
        if (record.accountTafsilType === 9) {
            this.onEditSolution(record.tafsilObjectId);
            return;
        }
        this.onEdit(record.id);
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Tafsil Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Tafsil Caller={this} /> });
    }
    onTransfer(id) {
        this.removeKeyDown();
        this.showComponents({ component: <AccountTransfer Caller={this} Id={id} OrganizationId={this.state.data.global.company.id} AccountType={4} /> });
    }
    onEditCashDesk(id) {
        this.removeKeyDown();
        this.showComponents({ component: <CashDesk Caller={this} Id={id} /> });
    }
    onEditBankAccount(id) {
        this.removeKeyDown();
        this.showComponents({ component: <BankAccount Caller={this} Id={id} /> });
    }
    onEditPerson(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Person Caller={this} Id={id} /> });
    }
    onEditStuff(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} Id={id} /> });
    }
    onEditBuildingUnit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Unit Caller={this} Id={id} /> });
    }
    onEditOrgUnit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <OrgUnit Caller={this} Id={id} /> });
    }
    onEditSolution(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Solution Caller={this} Id={id} /> });
    }  
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست حساب های تفصیلی</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} حساب یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="btn btn-primary hand" onClick={e => this.onAdd()}><span>حساب جدید</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/accounttypes/" className="hand btn btn-warning"><em className="icon ni ni-list"></em><span>انواع سایر تفصیل ها</span></NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>

                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام حساب" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.code} onChange={e => this.state.filters.code = e.target.value} placeholder="کدحساب" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.type} onChange={e => this.state.filters.type = parseInt(e.target.value)} className="form-control input-sm">
                                                    <option value="-1">همه نوع حسابها</option>
                                                    <option value="0">تفصیل عادی</option>
                                                    <option value="1">اشخاص و مشتریان</option>
                                                    <option value="2">کالاها و خدمات</option>
                                                    <option value="3">حسابهای بانکی</option>
                                                    <option value="4">صندوق ها</option>
                                                    <option value="5">مراکز درآمدی</option>
                                                    <option value="6">مراکز هزینه ای</option>
                                                    <option value="7">واحد ساختمان</option>
                                                    <option value="8">واحد سازمانی</option>
                                                    <option value="9">پروژه</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ حسابی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">کد</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نام</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">مانده</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تشخیص</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.fullCode}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.doEdit(record)} title="مشاهده و ویرایش">
                                                            {record.title}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.typeString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">مانده: </span>
                                                    <span className="sub-text text-center">{this.money(record.balance)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">تشخیص: </span>
                                                    <span className="sub-text text-center">{record.balanceDirection === 0 ? "" : record.balanceDirection === 1 ? "بدهکار" : "بستانکار"}</span>
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <em className="icon ni ni-cross-fill-c"></em>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onTransfer(record.id)} title="انتقال">
                                                        <em className="icon ni ni-copy"></em>
                                                    </a>
                                                    <NavLink className="hand text-warning mx-1" to={"/report/transaction/" + record.accountTafsilType + "/" + record.fullCode + "/"} title="مشاهده تراکنش های حساب">
                                                        <em className="icon ni ni-file-docs"></em>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}